import { executeRequest, Request } from '@jfs/network'
import { cancelPaymentLinkParser } from '../network/parsers/CancelPaymentLinkParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = cancelPaymentLinkParser(data)
  return respData
}

const cancelPaymentLinkRequest = (req: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.cancelPaymentLink,
    method: 'POST',
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { cancelPaymentLinkRequest }
